import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import CareersProfilePage from "@/pages/admin/CareersProfilePage";

export const Route = createFileRoute("/_admin/admin/careers-profile")({
  head: () => pageHead("Admin · Careers Profile", "AKIVA admin · careers profile portal.", "/admin/careers-profile", true),
  component: CareersProfilePage,
});
